import { render, staticRenderFns } from "./CommunicationsLogView.vue?vue&type=template&id=0aa23daa&scoped=true&"
import script from "./CommunicationsLogView.vue?vue&type=script&lang=ts&"
export * from "./CommunicationsLogView.vue?vue&type=script&lang=ts&"
import style0 from "./CommunicationsLogView.vue?vue&type=style&index=0&id=0aa23daa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa23daa",
  null
  
)

export default component.exports